/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReimbursementType = {
    Levels: 'levels',
    Pdpm: 'pdpm'
} as const;
export type ReimbursementType = typeof ReimbursementType[keyof typeof ReimbursementType];


export function ReimbursementTypeFromJSON(json: any): ReimbursementType {
    return ReimbursementTypeFromJSONTyped(json, false);
}

export function ReimbursementTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReimbursementType {
    return json as ReimbursementType;
}

export function ReimbursementTypeToJSON(value?: ReimbursementType | null): any {
    return value as any;
}

